import React from 'react';
import { Table, TableCell, TableHead } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import {
  ActionTakenType,
  DocumentTemplateType,
  IComment,
  INumberedDocumentView,
} from '../../../api-client/autogenerated';
import { getDocumentIdentifier } from '../../../scripts/utils';
import PackageListItem from './PackageListItem';
import { useSelector } from 'react-redux';
import { getDocumentsType } from '../../../features/documents/selectors';
import TableRow from '@material-ui/core/TableRow';

export type SubmittalInfo = {
  document: INumberedDocumentView;
  actionTaken?: ActionTakenType;
  comment?: string;
  existingComments?: IComment[];
};

interface Props {
  submittalInfo: SubmittalInfo[];
  handleActionTakenChange: (event: any, index: number) => void;
  handleCommentChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
  ) => void;
  handleRemoveComment: (commentId: string, index: number) => void;
  isConsultantReview?: boolean;
}

export default function PackageListTable(props: Props) {
  const {
    submittalInfo,
    handleActionTakenChange,
    handleCommentChange,
    handleRemoveComment,
    isConsultantReview,
  } = props;

  const documentTypeState = useSelector(getDocumentsType)!;

  const documentType =
    documentTypeState === DocumentTemplateType.AsBuilt
      ? DocumentTemplateType.AsBuiltPackages
      : documentTypeState;

  return (
    <Table size="small" style={{ marginTop: 16 }}>
      <TableHead>
        <TableRow>
          <TableCell />
          <TableCell>
            <Typography>
              {documentTypeState === DocumentTemplateType.AsBuilt ? 'Sheet Number' : 'Submittal #'}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography>Description</Typography>
          </TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      {submittalInfo
        .sort((a, b) =>
          getDocumentIdentifier(a.document, documentType).localeCompare(
            getDocumentIdentifier(b.document, documentType),
          ),
        )
        .map((info, index) => (
          <PackageListItem
            key={index}
            index={index}
            document={info.document}
            actionTaken={info.actionTaken}
            onActionTakenChange={handleActionTakenChange}
            comment={info.comment}
            onCommentChange={handleCommentChange}
            existingComments={info.existingComments}
            onRemoveComment={handleRemoveComment}
            isConsultantReview={isConsultantReview}
          />
        ))}
    </Table>
  );
}
